import React, { Component } from 'react';
import Flickity from 'flickity';
export default class SubSelector extends Component {
  constructor(props) {
    super(props)
    this.state = {
      selectedIndex: 0,
    }
  }

  componentDidMount() {
    const { items } = this.props;
    this.scrollAt = 1 / (items.length);
    this.initFlickity();
  }

  initFlickity = () => {
    const options = {
      cellSelector: '.item',
      contain: false,
      accessibility: false,
      pageDots: false,
      wrapAround: true,
      prevNextButtons: false,
      cellAlign: 'right'
    }

    this.flkty = new Flickity(this.wrapper, options);

    this.flkty.on('dragStart', this.dragStart);
    this.flkty.on('dragEnd', this.dragEnd);
    this.flkty.on('staticClick', this.staticClick);
    this.flkty.on('scroll', this.onScroll);
  };

  componentWillReceiveProps(nextProps) {
    this.flkty.selectCell(nextProps.selectedIndex);
  };

  staticClick = (event, pointer, cellElement, cellIndex) => {
    this.allowClick = false;
    this.props.slideTo(cellIndex, false);
    this.flkty.selectCell(cellIndex);
  };

  onScroll = scroll => {
    if (this.dragStarted) {
      if (scroll > (this.scrollAt * (this.state.selectedIndex + 1))) {
        const next = this.state.selectedIndex += 1;
        this.setState({
          selectedIndex: next,
        });

        this.props.slideTo(next, false);
      }

      if (scroll < this.scrollAt * (this.props.selectedIndex)) {
        const prev = this.state.selectedIndex -= 1;
        this.setState({
          selectedIndex: prev,
        });

        this.props.slideTo(prev, false);
      }
    }
    this.props.onSettle(this.flkty.selectedIndex);
  };

  dragStarted = false;

  dragStart = e => {
    this.dragStarted = true;
  };

  dragEnd = e => {
    this.dragStarted = false;
  };

  render() {
    const items = this.props.items

    return (
      <div ref={c => this.wrapper = c}>
        {items && items
          .filter(prop => prop.acf.show_in_slider && prop.acf.show_in_slider.includes("y"))
          .sort((a, b) => a.menu_order - b.menu_order)
          .map((item, k) =>
          <div key={item.id} className="item w-full md:w-1/3 xl:w-1/3 mx-4 image gallery-cell">
            <img className="inner mx-auto w-48 h-48 rounded-full bg-black flex-grow-0 shadow-xl flex-shrink-0 ease-in-out duration-500 object-cover" src={item.better_featured_image && item.better_featured_image.source_url} alt="" />
          </div>
        )}
      </div>
    );
  }
}
